import { I18nService } from '../../i18n/I18nService';
import { I18N_KEYS } from '../../i18n/keys';
import { FocusTrap } from '../../accessibility/FocusTrap';

export class CompletionModal {
  private i18n: I18nService;
  private focusTrap: FocusTrap;
  private dialog: HTMLDialogElement | null = null;

  onViewHistory: (() => void) | null = null;
  onNewGame: (() => void) | null = null;

  constructor(i18n: I18nService, focusTrap: FocusTrap) {
    this.i18n = i18n;
    this.focusTrap = focusTrap;
  }

  render(): void {
    this.dialog = document.getElementById('completion-modal') as HTMLDialogElement;
    if (!this.dialog) {
      this.dialog = document.createElement('dialog');
      this.dialog.id = 'completion-modal';
      this.dialog.className = 'modal modal--completion';
      document.body.appendChild(this.dialog);
    }
  }

  open(count: number, time: string, styleName: string): void {
    if (!this.dialog) this.render();

    this.dialog!.innerHTML = `
      <div class="modal__content">
        <h2>${this.i18n.t(I18N_KEYS.COMPLETE_TITLE)}</h2>
        <div class="completion__summary">
          <p>${this.i18n.t(I18N_KEYS.COMPLETE_NUMBERS_CALLED, { count })}</p>
          <p>${this.i18n.t(I18N_KEYS.COMPLETE_TIME_ELAPSED, { time })}</p>
          <p>${this.i18n.t(I18N_KEYS.COMPLETE_STYLE, { style: styleName })}</p>
        </div>
        <div class="modal__footer">
          <button id="completion-history-btn" class="btn btn--secondary" type="button">${this.i18n.t(I18N_KEYS.COMPLETE_VIEW_HISTORY)}</button>
          <button id="completion-newgame-btn" class="btn btn--primary" type="button">${this.i18n.t(I18N_KEYS.COMPLETE_NEW_GAME)}</button>
        </div>
      </div>
    `;

    this.dialog!.querySelector('#completion-history-btn')?.addEventListener('click', () => {
      this.close();
      if (this.onViewHistory) this.onViewHistory();
    });

    this.dialog!.querySelector('#completion-newgame-btn')?.addEventListener('click', () => {
      this.close();
      if (this.onNewGame) this.onNewGame();
    });

    this.dialog!.showModal();
    this.focusTrap.activate(this.dialog!);
  }

  close(): void {
    this.focusTrap.deactivate();
    if (this.dialog?.open) {
      this.dialog.close();
    }
  }

  isOpen(): boolean {
    return this.dialog?.open === true;
  }
}
